export default __webpack_public_path__ + "static/media/image 175.5c55da60.png";